import { takeLatest, call, put } from 'redux-saga/effects'
import { createTaskInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import * as fromActions from '../../../actions/blocks.action'

async function handleCreateTaskBlock(data: any) {
  return await createTaskInstance(data)
}

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

function* newTaskBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleCreateTaskBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createTaskWatcherSaga() {
  yield takeLatest(fromActions.TASK_BLOCK_CREATE, newTaskBlockEffectSaga)
}
